<template>
  <header class="bg-white/80 backdrop-blur-md shadow-lg rounded-xl flex items-center justify-between px-4 lg:px-4 py-3 transition-all duration-300">

    <!-- IZQUIERDA -->
    <div class="flex items-center gap-x-3 flex-1">
      <!-- Mobile menu button -->
      <button @click="$emit('toggle-sidebar')" class="lg:hidden text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-green-500">
        <span class="sr-only">Open sidebar</span>
        <font-awesome-icon icon="bars" class="h-6 w-6" />
      </button>
      <Breadcrumbs :currentPage="currentRouteName" class="flex" />
    </div>

    <!-- DERECHA -->
    <div class="flex items-center gap-x-2 shrink-0">
      <button @click="changeLanguage('es')" class="transition hover:scale-125 cursor-pointer">
        <img src="@/assets/img/ar.svg" class="h-5 md:h-8 rounded-full" />
      </button>
      <button @click="changeLanguage('en')" class="transition hover:scale-125 cursor-pointer">
        <img src="@/assets/img/us.svg" class="h-5 md:h-8 rounded-full" />
      </button>
    </div>

  </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Breadcrumbs from "@/components/layout/Breadcrumbs.vue";
import idiomaService from '@/services/idioma.services';

export default defineComponent({
  props: {
    minNav: Boolean,
  },
  components: {
    Breadcrumbs
  },
  computed: {
    currentRouteName(): string {
      let i18nName = this.$route.name as string;
      if (i18nName) {
        return this.$t(i18nName);
      }
      return "No name";
    }
  },
  methods: {
    changeLanguage(lang: string) {
      this.$i18n.locale = lang;
      idiomaService.updateIdioma(lang);
    }
  }
});
</script>